export const housesViews = {
  list: 'list',
  cameras: 'cameras',
};
